module.exports = __webpack_public_path__ + "img/home_product_ambient.84b80df4.jpg";